import Layout from '@/layout'

export default {
  path: '/order',
  component: Layout,
  redirect: '/order/list',
  name: 'order',
  meta: {
    title: '交易管理',
    role: 1511,
    icon: 'trade'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/pages/order/list'),
      name: 'orderList',
      meta: { title: '我的订单', role: 1512 }
    },
    {
      path: 'detail/:id',
      component: () => import('@/pages/order/detail'),
      name: 'orderDetail',
      hidden: true,
      meta: { title: '订单详情', role: 1512, type: 'copy' }
    },
    {
      path: 'detailExportRecord/:id',
      component: () => import('@/pages/order/exportRecord'),
      name: 'orderDetailExportRecord',
      hidden: true,
      meta: { title: '导入记录', role: 1512 }
    },
    {
      path: 'refundlist',
      name: 'refundList',
      component: () => import('@/pages/refund/refund'),
      meta: { title: '售后订单', role: 1519 }
    }
  ]
}
